import React from 'react'
import { Chart as ChartJS, ArcElement } from 'chart.js'

import { Doughnut } from 'react-chartjs-2'
ChartJS.register(ArcElement)

const PercentageChart = ({studentDetails}) => {
  
const plugins = [
  {
    afterDraw: function (chart) {
      
      let width = chart.width,
        height = chart.height,
        ctx = chart.ctx
      ctx.font = 'bolder 20px arial'
      ctx.fillStyle = '#343E59'
      ctx.textAlign = 'center'
      ctx.fillText(studentDetails?.profileCompletionPerc+'%', width / 2, height / 2)
      ctx.save()
    },
  },
]
const data = {
  labels: ['Completed', 'InComplete'],
  datasets: [
    {
      data: [studentDetails?.profileCompletionPerc, 100 - studentDetails?.profileCompletionPerc],
      borderWidth: 0,
      borderRadius: 5,
      cutout: '70%',
      backgroundColor: ['#3249D7', '#EBECEE'],
    },
  ],
}

  return (
  
      <div className="chart">
        <Doughnut
          data={data}
          width={150}
          height={150}
          plugins={plugins}
          options={{
            plugins: {
              legend: {
                display: false,
                position: 'right',
              },
            },

            maintainAspectRatio: false,
          }}
        />
      </div>
    
  )
}

export default PercentageChart
